import {createApplicationWalkthrough} from '@walkthroughs/definitions/createApplication';
import {Walkthrough} from '@core/types/walkthrough';

export const walkthroughs: Record<string, Walkthrough> = {
  [createApplicationWalkthrough.id]: createApplicationWalkthrough,
};

export const getWalkthrough = (id: string): Walkthrough | undefined => {
  return walkthroughs[id];
};
